import tealium, { ActionType } from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

export const pageViews = {
  pageLoaded: ActionType.VIEW,
};

async function trackPageLoaded(_: string, eventData: IDataLayer = {}) {
  if (eventData?.['analytics-datalayer']) {
    const analytics_datalayer = eventData['analytics-datalayer'] || {};

    analytics_datalayer['previous_url'] = eventData.previousUrl || '';
    analytics_datalayer['current_url'] = eventData.currentUrl || '';

    delete eventData.previousUrl;
    delete eventData.currentUrl;

    window.page_data = eventData as { 'analytics-datalayer': IDataLayer };

    tealium.dataLayer.reset({ ...analytics_datalayer });

    try {
      await tealium.dataLayer.load(); // Await the load operation
      tealium.evtView(tealium.dataLayer.data);
    } catch (error) {
      console.error(
        'Failed to load the data layer for trackPageLoaded Event:',
        error,
      );
    }
  }
}

registerAnalyticsEventHandler('pageLoaded', trackPageLoaded);
